/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rental_Blocked_DatesInputs */

const en_rental_blocked_dates = /** @type {(inputs: Rental_Blocked_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selected dates are unavailable. Please choose different dates.`)
};

const es_rental_blocked_dates = /** @type {(inputs: Rental_Blocked_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las fechas seleccionadas no están disponibles. Por favor elige otras.`)
};

const fr_rental_blocked_dates = /** @type {(inputs: Rental_Blocked_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les dates sélectionnées sont indisponibles. Veuillez en choisir d'autres.`)
};

const de_rental_blocked_dates = /** @type {(inputs: Rental_Blocked_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählte Daten sind nicht verfügbar. Bitte wähle andere Daten.`)
};

const id_rental_blocked_dates = /** @type {(inputs: Rental_Blocked_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanggal yang dipilih tidak tersedia. Harap pilih tanggal lain.`)
};

/** @type {(inputs: Rental_Blocked_DatesInputs) => LocalizedString} */
const ja_rental_blocked_dates = en_rental_blocked_dates;

/** @type {(inputs: Rental_Blocked_DatesInputs) => LocalizedString} */
const zh_rental_blocked_dates = en_rental_blocked_dates;

/** @type {(inputs: Rental_Blocked_DatesInputs) => LocalizedString} */
const ar_rental_blocked_dates = en_rental_blocked_dates;

/** @type {(inputs: Rental_Blocked_DatesInputs) => LocalizedString} */
const it_rental_blocked_dates = en_rental_blocked_dates;

/** @type {(inputs: Rental_Blocked_DatesInputs) => LocalizedString} */
const ru_rental_blocked_dates = en_rental_blocked_dates;

/** @type {(inputs: Rental_Blocked_DatesInputs) => LocalizedString} */
const pt_rental_blocked_dates = en_rental_blocked_dates;

/** @type {(inputs: Rental_Blocked_DatesInputs) => LocalizedString} */
const ko_rental_blocked_dates = en_rental_blocked_dates;

/**
* | output |
* | --- |
* | "Selected dates are unavailable. Please choose different dates." |
*
* @param {Rental_Blocked_DatesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_blocked_dates = /** @type {((inputs?: Rental_Blocked_DatesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Blocked_DatesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_blocked_dates(inputs)
	if (locale === "es") return es_rental_blocked_dates(inputs)
	if (locale === "fr") return fr_rental_blocked_dates(inputs)
	if (locale === "de") return de_rental_blocked_dates(inputs)
	if (locale === "ja") return ja_rental_blocked_dates(inputs)
	if (locale === "zh") return zh_rental_blocked_dates(inputs)
	if (locale === "ar") return ar_rental_blocked_dates(inputs)
	if (locale === "id") return id_rental_blocked_dates(inputs)
	if (locale === "it") return it_rental_blocked_dates(inputs)
	if (locale === "ru") return ru_rental_blocked_dates(inputs)
	if (locale === "pt") return pt_rental_blocked_dates(inputs)
	return ko_rental_blocked_dates(inputs)
});